/**
 * @generated SignedSource<<002fcfde8540b2b7bad6cb11198804c2>>
 * @relayHash db5beca17477e4ab08cc69f69dc5ce42
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID db5beca17477e4ab08cc69f69dc5ce42

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type de_BetterDocRecommendationDelivery = "MSN" | "PMN";
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type de_BetterDocRecommendationStateGroup = "FAILED" | "OPEN" | "RECOMMENDED" | "REJECTED" | "SELECTED";
export type de_BetterDocRemoteRequestStatus = "INVALID_RECOMMENDATION_ID" | "NOT_FOUND" | "RECEIVED" | "REQUEST_FAILED" | "UNEXPECTED_RESPONSE";
export type de_BetterDocSecondOpinion = "NOT_APPLICABLE" | "NOT_REQUIRED" | "REQUIRED";
export type betterDocRemoteRecommendationsQuery$variables = {
  insuranceCountry: Country;
  stateGroup: de_BetterDocRecommendationStateGroup;
  updatedAfter: any;
};
export type betterDocRemoteRecommendationsQuery$data = {
  readonly de_betterDocRemoteRecommendations: {
    readonly errorReason: string | null;
    readonly exchangeId: number | null;
    readonly hasMoreRecommendations: boolean;
    readonly httpStatusCode: number | null;
    readonly recommendations: ReadonlyArray<{
      readonly localSessionId: number | null;
      readonly medics: ReadonlyArray<{
        readonly selectionId: number;
      }>;
      readonly partnerPatientId: string;
      readonly partnerSessionId: string;
      readonly recommendationDelivery: de_BetterDocRecommendationDelivery | null;
      readonly recommendationId: string;
      readonly secondOpinion: de_BetterDocSecondOpinion | null;
      readonly state: de_BetterDocRecommendationState;
      readonly updatedAt: string;
    }>;
    readonly status: de_BetterDocRemoteRequestStatus;
  };
};
export type betterDocRemoteRecommendationsQuery = {
  response: betterDocRemoteRecommendationsQuery$data;
  variables: betterDocRemoteRecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "insuranceCountry"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stateGroup"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updatedAfter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "insuranceCountry",
        "variableName": "insuranceCountry"
      },
      {
        "kind": "Variable",
        "name": "stateGroup",
        "variableName": "stateGroup"
      },
      {
        "kind": "Variable",
        "name": "updatedAfter",
        "variableName": "updatedAfter"
      }
    ],
    "concreteType": "de_BetterDocRemoteRecommendationsResult",
    "kind": "LinkedField",
    "name": "de_betterDocRemoteRecommendations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "httpStatusCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "exchangeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasMoreRecommendations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocRemoteRecommendation",
        "kind": "LinkedField",
        "name": "recommendations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationDelivery",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondOpinion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerPatientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "localSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocRemoteMedic",
            "kind": "LinkedField",
            "name": "medics",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "selectionId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocRemoteRecommendationsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "betterDocRemoteRecommendationsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "db5beca17477e4ab08cc69f69dc5ce42",
    "metadata": {},
    "name": "betterDocRemoteRecommendationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3634c6e5c1c24a9e237f9416d11c11f2";

export default node;
